/**
 * @file index.tsx
 *
 * @fileOverview Renders job video.
 */

import React, { useContext } from 'react';
import { Job, LinkItem } from '~/jobiqo/types/types';
import EmbeddedVideo from '~/jobiqo/components/Landingpage/EmbeddedYoutube/components/EmbeddedVideo';
import Spacing from '~/vcl/atoms/06-layout/07-spacing';
import styles from './video.module.scss';
import { UserContext, UserContextInterface } from '~/jobiqo/context/user';
import { extractServiceFromUrl } from '~/jobiqo/utils/links';
import {
  checkVideoConsent,
  mapVideoTypeToService,
} from '~/jobiqo/components/Landingpage/utils/landingPage';
import AlignedCenter from '~/vcl/atoms/06-layout/01-alignment/01-align-center';
import { Text } from '~/vcl/atoms/13-text/03-text';
import { FormattedMessage } from 'react-intl';
import CMPServiceCheckbox from '~/jobiqo/components/CMPserviceCheckbox';

export interface JobDetailVideoProps {
  /**
   * The job.
   */
  job: Job;
}

export const JobDetailVideo = ({ job }: JobDetailVideoProps) => {
  const userContext: UserContextInterface = useContext(UserContext);
  let consented = true;
  let service = '';
  // As we want to use EmbeddedVideo component, we need to create a LinkItem object
  // from the videoUrl string.
  let videoLinkItem: LinkItem = {} as LinkItem;
  if (job['videoUrl']) {
    service = extractServiceFromUrl(job['videoUrl']);
    consented = checkVideoConsent(service, userContext);
    videoLinkItem['url'] = job['videoUrl'];
  } else {
    return null;
  }

  return consented ? (
    <div className={styles.jobDetailVideo}>
      <EmbeddedVideo link={videoLinkItem} />
      <Spacing size="large" />
    </div>
  ) : (
    <Spacing margin={0} padding={7}>
      <AlignedCenter>
        <Text marginTop="0">
          <FormattedMessage
            id="video_teasers_row_consent"
            defaultMessage="Consent to this service"
          />
        </Text>
        <Spacing />
        <CMPServiceCheckbox serviceId={mapVideoTypeToService(service)} />
      </AlignedCenter>
    </Spacing>
  );
};

export default JobDetailVideo;
